// Libraries
import _ from 'lodash';

// Supermove
import {gql} from '@supermove/graphql';
import {StageModel} from '@supermove/models';
import {colors} from '@supermove/styles';
import {withFragment} from '@supermove/utils';

// Shared
import ProjectStatus from '@shared/modules/Project/enums/ProjectStatus';

const COLOR_SELECTOR_OPTIONS = {
  Purple: colors.purple.status,
  Blue: colors.blue.interactive,
  Green: colors.green.status,
  Yellow: colors.yellow.status,
  Orange: colors.orange.status,
  Red: colors.red.warning,
  Pink: '#E84393',
  Grey: colors.gray.secondary,
  Black: colors.black,
};

const getColorNameFromValue = (value?: string) => {
  const colorName = Object.keys(COLOR_SELECTOR_OPTIONS).find(
    (key) => COLOR_SELECTOR_OPTIONS[key as keyof typeof COLOR_SELECTOR_OPTIONS] === value,
  );
  return _.startCase(_.toLower(colorName || ''));
};

const getColorSelectorDropdownOptions = () =>
  Object.keys(COLOR_SELECTOR_OPTIONS).map((key, index) => ({
    label: key,
    value: COLOR_SELECTOR_OPTIONS[key as keyof typeof COLOR_SELECTOR_OPTIONS],
    index,
  }));

const getOrderedStages = withFragment<{stages: StageModel[]}, StageModel[]>(
  ({stages}) => {
    const groupedStages = _.groupBy(stages, (stage: StageModel) => stage.projectStatus);
    return [...groupedStages[ProjectStatus.LEAD], ...groupedStages[ProjectStatus.BOOKED]];
  },
  gql`
    fragment Stage_getOrderedStages on Stage {
      id
      projectStatus
    }
  `,
);

const Stage = {
  getColorSelectorDropdownOptions,
  getColorNameFromValue,
  getOrderedStages,
};

export default Stage;
